module.exports = __webpack_public_path__ + "media/fonts/Inter-Bold-e2cf90a4870ee378777ebaa927c605f0.woff";